import { FC, useEffect, useRef, useState } from 'react';
import FilesList, { Ref } from '../../components/FilesList/FilesList';
import { File } from '../../components/FilesList/types';
import {
  SpheraHeader,
  SpheraNotification,
  SpheraNotificationGroup,
} from '@sphera-cloud/component-ui-reactjs';
import { FileUploadModal } from 'src/components/FileUploadModal/FileUploadModal';
import { INotificationObj } from './types';
import { fetchFileSpec, fileSpecSelector, isLoadingSelector } from 'src/store/slices/fileSpec';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useSpinnerContext } from 'src/context/SpinnerContext';
import { useNavigate } from 'react-router-dom';
import { clearJobs } from "src/store/slices/jobs";

const defaultNotification = { isOpen: false, type: '', text: '' };

export const FilesPage: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { setShowSpinner } = useSpinnerContext();
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState(defaultNotification);
  const fileSpec = useAppSelector(fileSpecSelector);
  const isLoading = useAppSelector(isLoadingSelector);
  const [selectedFiles, setSelectedFiles] = useState<Record<string, File>>({});

  const fileListRef = useRef<Ref>();

  useEffect(() => {
    setShowSpinner(isLoading);
  }, [isLoading]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(fetchFileSpec());
    }, 0);
    return () => clearTimeout(delayDebounceFn);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearJobs(undefined));
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearJobs(undefined));
    };
  }, []);

  const generateNotificationObj = (type: string, message: string): INotificationObj => {
    return {
      isOpen: true,
      type,
      text: message,
    };
  };

  const showNotification = (type: string, message: string) => {
    setNotification(generateNotificationObj(type, message));
    setTimeout(() => {
      setNotification(defaultNotification);
    }, 5000);
  };

  const openModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  return (
    <div className="page files-page inner-content">
      <SpheraHeader
        text="Files"
        navigate={navigate}
        breadcrumbData={[
          { id: 1, text: 'Sphera Cloud LCA', link: '/' },
          {
            id: 2,
            text: 'Files',
            link: '/files',
          },
        ]}
        button={[{
          type: Object.keys(selectedFiles ?? {}).length ? 'secondary' : 'disabled',
          icon: 'icon-ui-general-delete',
          onClick: () => {
            fileListRef.current?.removeSelectedFiles();
          },
          tooltip: 'Delete files',
          position: 'top',
        },
        {
          type: 'primary',
          icon: '',
          text: 'Add File',
          onClick: () => {
            openModal();
          },
          tooltip: '',
          position: '',
        },
        ]}
      />
      {visible && (
        <FileUploadModal
          closeModal={closeModal}
          showNotification={showNotification}
          types={fileSpec.items}
        />
      )}
      {!!fileSpec.items.length && (
        <FilesList ref={fileListRef} showNotification={showNotification} types={fileSpec.items} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} />
      )}
      <SpheraNotificationGroup
        position={{
          top: 70,
          right: 30,
        }}
      >
        {notification.isOpen && (
          <SpheraNotification
            closable={true}
            type={notification.type}
            text={notification.text}
            onClose={() => setNotification(defaultNotification)}
          />
        )}
      </SpheraNotificationGroup>
    </div>
  );
};
